<template>
  <div style="background:#fff;">
    <div class="page_title flex_between">
      <span>添加教程</span>
      <el-button type="primary"
                 style="width:92px;"
                 size="medium"
                 @click="back">返回</el-button>
    </div>
    <div class="container">
      <div class="essay">
        <div class="item">
          <div class="title">标题</div>
          <el-input v-model="title"
                    placeholder="请输入标题"
                    maxlength="100"
                    show-word-limit></el-input>
        </div>
        <div class="item">
          <div class="title">图片</div>
          <div class="uploadImg-box">
            <UploadImg :f_thumb="image"
                       :f_thumb_str="image_str"
                       @emitImg="emitImg"></UploadImg>
            <div class="prompt">建议尺寸686*232px</div>
          </div>
        </div>
        <div class="item"
             style="width:100%;height:100%; align-items: flex-start;">
          <div class="title"
               style="padding-top:6px">内容</div>
          <wangeditorNew ref="editorBox"
                         @changeCheck="changeCheck"
                         :margins="margins" />
        </div>
        <div class="btnbox"
             v-if="$route.query.is_look != 1">
          <div>
            <el-button type="primary"
                       round
                       style="width:100px;margin-right:5px"
                       @click="submit">保存</el-button>
            <el-button plain
                       round
                       style="width:100px"
                       @click="back">退出</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wangeditorNew from '../wangeditorNew';
import UploadImg from '@/components/uploadImg/index';
import imgtext from '../../../api/imgtext';
export default {
  data() {
    return {
      title: '',
      content: '',
      margins: 1,
      image: '',
      image_str: ''
    };
  },
  components: {
    wangeditorNew,
    UploadImg
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    getId() {
      return this.$route.query.vt_id;
    }
  },
  created() {
    this.margins = 1;
    if (this.$route.query.vt_id != -99) {
      this.getDetail();
    }
  },
  methods: {
    //发布
    submit() {
      if (!this.title) {
        this.$message.error('请填写标题');
        return false;
      }
      this.content = this.$refs.editorBox.editor.getHtml();
      if (!this.content) {
        this.$message.error('请填写文本内容');
        return false;
      }
      if (!this.image) {
        this.$message.error('请上传图片');
        return false;
      }
      let params = {
        title: this.title,
        content: this.content,
        margins: this.margins,
        image: this.image
      };
      let interfaceName = 'doctortutorialAdd';
      if (this.getId == -99) {
        interfaceName = 'doctortutorialAdd';
      } else {
        interfaceName = 'doctortutorialModify';
        params.vt_id = this.getId;
      }
      imgtext[interfaceName](params).then((res) => {
        if (res.code == 0) {
          this.$message.success(`${this.getId == -99 ? '保存' : '编辑'}成功`);
          this.back();
        }
      });
    },
    //获取
    getDetail() {
      let loading = this.$loading();
      let vt_id = this.getId;
      imgtext
        .doctortutoriaGetOne({ vt_id })
        .then((res) => {
          if (res.code == 0) {
            let detail = res.data;
            this.title = detail.title;
            this.margins = detail.margins;
            this.image = detail.image_half;
            this.image_str = detail.image_full;
            if (detail.content) {
              this.setDesc(detail.content);
            }
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    //往编辑器里插入数据
    setDesc(text) {
      this.$refs.editorBox.editor.setHtml(text);
    },
    //获取边距
    changeCheck(value) {
      this.margins = value;
    },
    back() {
      history.back();
    },
    emitImg(data) {
      let { pic, path } = data;
      this.image = pic;
      this.image_str = path;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 120px);
  background: #fff;
}
.essay {
  width: 80%;
  margin: 20px auto 0;
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .title {
      width: 80px;
      font-size: 16px;
    }
    .title::before {
      content: '*';
      color: #f56c6c;
      margin-right: 4px;
    }
    .uploadImg-box {
      display: flex;
      align-items: flex-end;
      .prompt {
        height: 30px;
        margin-left: 20px;
      }
    }
  }
}
.btnbox {
  width: 100%;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 30px;
  box-sizing: border-box;
  background: #fff;
}
</style>
